import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export function getFilters() {
  return async (dispatch) => {
    dispatch(getFiltersInit());
    try {
      const responseRegiones = await axios.get(`${API_URL}/ms-catalogos/filtros/region`);
      const responseInmuebles = await axios.get(`${API_URL}/ms-catalogos/filtros/inmuebleByGrupoAndRegion`);
      const responseGrupos = await axios.get(`${API_URL}/ms-catalogos/filtros/grupoinmueble`);
      const responseNodos = await axios.post(`${API_URL}/ms-catalogos/filtros/nodo/ByInmuebleOrNodeId`,{
        "grupoInmuebleId": 0,
        "regionId": 0,
        "inmuebleId": 0,
        "nodeId": 0
      });

      const inmueblesData = await responseInmuebles.data ? responseInmuebles.data : [];
      const regionesData = await responseRegiones.data.data ? responseRegiones.data.data : [];
      const gruposData = await responseGrupos.data.data ? responseGrupos.data.data : [];
      const nodosData = await responseNodos.data.data ? responseNodos.data.data : [];
       
      dispatch(
        filtersSuccess({
          inmuebles: inmueblesData,
          regiones: regionesData,
          grupos: gruposData,
          nodos: nodosData
        })
      );
    } catch (error) {
      dispatch(filtersError(error));
    }
  };
}

export function getGrupos(regionId,regionesData) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/ms-catalogos/filtros/grupoinmueble/${regionId}`);
      const params = {};
      if (regionId) {
        params.regionId = regionId;
      }
      const responseInm = await axios.get(`${API_URL}/ms-catalogos/filtros/inmuebleByGrupoAndRegion`, { params });

      const responseNodo = await axios.post(`${API_URL}/ms-catalogos/filtros/nodo/ByInmuebleOrNodeId`, {
        "grupoInmuebleId":  0,
        "regionId": regionId || 0,
        "inmuebleId": 0,
        "nodeId": 0
      });
      const nodosData = responseNodo?.data?.data ? responseNodo?.data?.data : [];
      const inmueblesData = responseInm.data ? responseInm.data : [];
      const gruposData = response.data.data ? response.data.data : [];
      dispatch(filtersSuccess({ 
        regiones: regionesData,
        grupos: gruposData,
        inmuebles: inmueblesData,
        nodos: nodosData}
      ));
    } catch (error) {
      dispatch(filtersError(error));
    }
  };
}

export function getInmuebles(regionId, grupoInmuebleId, regionesData,gruposData) {
  return async (dispatch) => {
    try {
      const params = {};
      if (regionId) {
        params.regionId = regionId;
      }
      if (grupoInmuebleId) {
        params.grupoInmuebleId = grupoInmuebleId;
      }
      const response = await axios.get(`${API_URL}/ms-catalogos/filtros/inmuebleByGrupoAndRegion`);
      const responseNodo = await axios.post(`${API_URL}/ms-catalogos/filtros/nodo/ByInmuebleOrNodeId`, {
        "grupoInmuebleId":  0,
        "regionId": regionId || 0,
        "inmuebleId": 0,
        "nodeId": 0
      });
      const nodosData = responseNodo?.data?.data ?  responseNodo?.data?.data : [];
      const inmueblesData = response.data ? response.data : [];
      dispatch(filtersSuccess({
        regiones: regionesData,
        inmuebles: inmueblesData,
        grupos: gruposData,
        nodos: nodosData
      }));
    } catch (error) {
      dispatch(filtersError(error));
    }
  };
}

export function getNodos(regionId, grupoInmuebleId, inmuebleId, regionesData,gruposData, inmueblesData) {
  return async (dispatch) => {
    try {
      const params = {};
      if (regionId) {
        params.regionId = regionId;
      }
      if (grupoInmuebleId) {
        params.grupoInmuebleId = grupoInmuebleId;
      }
      if (inmuebleId) {
        params.inmuebleId = inmuebleId;
      }
      const response = await axios.post(`${API_URL}/ms-catalogos/filtros/nodo/ByInmuebleOrNodeId`, {
        "grupoInmuebleId": grupoInmuebleId || 0,
        "regionId": regionId || 0,
        "inmuebleId": inmuebleId || 0,
        "nodeId": 0
      });
      const nodosData = response?.data?.data ? response?.data?.data : [];
      dispatch(filtersSuccess({
        regiones: regionesData,
        inmuebles: inmueblesData,
        grupos: gruposData,
        nodos: nodosData
      }));
    } catch (error) {
      dispatch(filtersError(error));
    }
  };
}

const getFiltersInit = () => ({ type: 'GET_FILTERS_INIT' });
const filtersError = (error) => ({ type: 'GET_FILTERS_ERROR', payload: error });
const filtersSuccess = (data) => ({ type: 'GET_FILTERS_SUCCESS', payload: data });

const initialState = {
  name: 'filter',
  state: false,
  loading: true,
  filter: {
    firsSection: {},
    charts: [],
    filters: {
      regiones: [],
      inmuebles: [],
      grupos: [],
      nodos: [],
      fechaIni: null,
      fechaFin: null
    },
  },
};

export default function init(state = initialState, action) {
  switch (action.type) {
    case 'GET_FILTERS_INIT':
      return {
        ...state,
        loading: true,
      };
    case 'GET_FILTERS_SUCCESS':
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          filters: action.payload,
        },
      };
    case 'GET_FILTERS_ERROR':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
